import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Form } from "@rentiohq/web-shared-next/dist/ui-components";
import { addCustomMessageSchema } from "tenant-dashboard/forms/customMessage";

interface IProps {
  property?: IProperty;
  showDialog: boolean;
  handleClose: () => void;
  handleSubmit: (values: any) => void;
}

export const AddCustomMessage = ({
  property,
  showDialog,
  handleClose,
  handleSubmit,
}: IProps) => {
  const { broker } = authHooks.useSelf();

  const getCustomMessageBody = () => {
    const params: { [key: string]: string | null | undefined } = {
      broker: broker?.name,
      property: property?.propertyAddress?.full,
    };

    let result = getLocalizedText("email.document_shared.body");
    Object.keys(params).forEach(key => {
      result = result.replaceAll(`{{${key}}}`, params[key] || "");
    });

    return result;
  };

  return (
    <Form
      getSchema={addCustomMessageSchema({
        customMessageBody: getCustomMessageBody(),
      })}
      onSubmit={handleSubmit}
      asMultiStep={false}
      showSummary={false}
      renderAsModal={true}
      modalProps={{
        modalTitle: getLocalizedText("share.document.custom_message.title"),
        openDialog: showDialog,
        handleClose,
      }}
    />
  );
};
